import { TaskProgressPanel } from '../TaskProgressPanel'
import styles from './TaskProgressPopout.module.css'
import { TaskProgressPopoutProps } from './TaskProgressPopout.types'

/**
 * The Observatory's floating task detail card. Purely the positioning shell — all of the content
 * lives in TaskProgressPanel, which the Execution Board's task focus modal reuses in its own
 * layout.
 */
export const TaskProgressPopout = ({
  task,
  showProgress = false,
  tripProgress,
  onClose,
  testId,
}: TaskProgressPopoutProps) => {
  const computedTestId = testId ?? `task-progress-popout-${task.taskDefinition.id}`

  return (
    <div className={styles.popout}>
      <TaskProgressPanel
        task={task}
        showProgress={showProgress}
        tripProgress={tripProgress}
        onClose={onClose}
        testId={computedTestId}
      />
    </div>
  )
}
